// src/pages/Tokenomics.js
import React, { useState } from "react";
import "../styles/tokenomics.css";
import { Pie, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
);

const Tokenomics = () => {
  const [activePolicy, setActivePolicy] = useState("liquidity");
  const pieData = {
    labels: [
      "Seed Sale",
      "Private Sale",
      "Public Sale",
      "Founder & Team",
      "Ecosystem & Partnerships",
      "Marketing",
      "Staking",
      "Liquidity",
      "Buyback & Burn",
    ],
    datasets: [
      {
        data: [5, 7, 18, 15, 15, 10, 10, 10, 10],
        backgroundColor: [
          "#34d399",
          "#60a5fa",
          "#c084fc",
          "#ef4444",
          "#fbbf24",
          "#a78bfa",
          "#38bdf8",
          "#f97316",
          "#f43f5e",
        ],
        borderWidth: 1,
      },
    ],
  };

  const barData = {
    labels: [
      "Seed",
      "Private",
      "Public",
      "Team",
      "Ecosystem",
      "Marketing",
      "Staking",
      "Liquidity",
    ],
    datasets: [
      {
        label: "Locking Period (Days)",
        data: [90, 90, 90, 730, 0, 0, 0, 0],
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        stack: "Stack 0",
      },
      {
        label: "Vesting Period (Months)",
        data: [24, 18, 12, 12, 24, 24, 24, 12],
        backgroundColor: [
          "#34d399",
          "#60a5fa",
          "#c084fc",
          "#ef4444",
          "#fbbf24",
          "#a78bfa",
          "#38bdf8",
          "#f97316",
        ],
        stack: "Stack 0",
      },
    ],
  };

  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: { color: "#fff" },
      },
    },
    scales: {
      x: {
        ticks: { color: "#fff" },
        grid: { color: "rgba(255,255,255,0.1)" },
      },
      y: {
        ticks: { color: "#fff" },
        grid: { color: "rgba(255,255,255,0.1)" },
      },
    },
  };

  return (
    <div className="tokenomics">
      <h2 className="tokenomics-title">Tokenomics Overview</h2>

      <div className="tokenomics-boxes">
        <div className="token-box">
          <h3>Token Distribution</h3>
          <ul>
            <li><strong>Seed Sale:</strong> 5% — 5 Billion MCN</li>
            <li><strong>Private Sale:</strong> 7% — 7 Billion MCN</li>
            <li><strong>Public Sale:</strong> 18% — 18 Billion MCN</li>
            <li><strong>Staking Rewards:</strong> 10%</li>
            <li><strong>Team & Advisors:</strong> 15% (24-month lock)</li>
            <li><strong>Ecosystem & Partnerships:</strong> 15%</li>
            <li><strong>Marketing & Airdrops:</strong> 10%</li>
            <li><strong>Liquidity Pool:</strong> 10%</li>
            <li><strong>Buyback & Burn:</strong> 10%</li>
          </ul>
        </div>
        <div className="token-box">
          <h3>ICO Stage Prices</h3>
          <ul>
            <li><strong>Seed:</strong> $0.001 / token</li>
            <li><strong>Private:</strong> $0.002 / token</li>
            <li><strong>Public:</strong> $0.004 / token</li>
          </ul>
          <h3>Vesting Schedule</h3>
          <ul>
            <li>Initial Lock: 90 days</li>
            <li>First Unlock: Seed (5%), Private (10%), Public (15%)</li>
            <li>Remaining unlocks quarterly over: 24 / 18 / 12 months</li>
          </ul>
        </div>
      </div>

      <div className="tokenomics-graphs">
        <div className="chart-container"><Pie data={pieData} /></div>
        <div className="chart-container"><Bar data={barData} options={barOptions} /></div>
      </div>

      <div className="total-supply">Total Supply: 100 Billion MCN</div>

      <div className="vesting-table">
        <table>
          <thead>
            <tr>
              <th>Category</th>
              <th>Lock Period</th>
              <th>Vesting Period</th>
              <th>TGE Unlock</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>Seed</td><td>90 Days</td><td>24 Months</td><td>5%</td></tr>
            <tr><td>Private</td><td>90 Days</td><td>18 Months</td><td>10%</td></tr>
            <tr><td>Public</td><td>90 Days</td><td>12 Months</td><td>15%</td></tr>
            <tr><td>Team</td><td>24 Months</td><td>12 Months</td><td>0%</td></tr>
            <tr><td>Ecosystem</td><td>0</td><td>24 Months</td><td>50%</td></tr>
            <tr><td>Marketing</td><td>0</td><td>24 Months</td><td>40%</td></tr>
            <tr><td>Staking</td><td>0</td><td>36 Months</td><td>0%</td></tr>
            <tr><td>Liquidity</td><td>0</td><td>12 Months</td><td>50%</td></tr>
            <tr><td>Buyback</td><td>Dynamic</td><td>Strategic</td><td>0%</td></tr>
          </tbody>
        </table>
      </div>

      {/* INVESTOR POLICIES SECTION */}
      <div className="policies-section">
        <h2 className="policies-title">📋 Investor Protection Policies</h2>
        
        <div className="policies-tabs">
          <button 
            className={`policy-tab ${activePolicy === "liquidity" ? "active" : ""}`}
            onClick={() => setActivePolicy("liquidity")}
          >
            Liquidity & Listing
          </button>
          <button 
            className={`policy-tab ${activePolicy === "treasury" ? "active" : ""}`}
            onClick={() => setActivePolicy("treasury")}
          >
            Treasury Sale
          </button>
          <button 
            className={`policy-tab ${activePolicy === "staking" ? "active" : ""}`}
            onClick={() => setActivePolicy("staking")}
          >
            Staking Emissions
          </button>
          <button 
            className={`policy-tab ${activePolicy === "burn" ? "active" : ""}`}
            onClick={() => setActivePolicy("burn")}
          >
            Burn Rule
          </button>
        </div>

        <div className="policy-content">
          {activePolicy === "liquidity" && (
            <div className="policy-item">
              <h3>Liquidity & Listing Policy</h3>
              <div className="policy-subsection">
                <h4>TL;DR</h4>
                <p>We'll list MCN on a DEX at a price slightly above our Public ICO price so the ICO stays the best deal. We'll add liquidity gradually as real trading grows, and we'll publish every liquidity transaction.</p>
              </div>

              <div className="policy-subsection">
                <h4>How it works</h4>
                <ul>
                  <li><strong>Listing price:</strong> We plan to list around $0.0048–$0.005 (Public ICO is $0.004).</li>
                  <li><strong>Initial pool size (TVL):</strong> Small on purpose ($10k–$25k) so price discovery is organic.</li>
                  <li><strong>Addresses & proof:</strong> We'll publish official contract addresses (Token, Presale, Vesting, LP Pair, LP Token) and link to the block explorer for verification.</li>
                  <li><strong>Liquidity ladder:</strong> As 30-day trading volume grows, we add more depth step-by-step so slippage gets better over time:
                    <ul>
                      <li>≥ $0.5M volume → add $100k liquidity</li>
                      <li>≥ $1.5M → add $150k</li>
                      <li>≥ $5.0M → add $300k</li>
                      <li>≥ $10.0M → add $500k</li>
                    </ul>
                  </li>
                  <li>Every add is announced, with a transaction link.</li>
                </ul>
              </div>

              <div className="policy-subsection">
                <h4>What this means for you</h4>
                <ul>
                  <li>The ICO is the best price during Seed/Private/Public.</li>
                  <li>The DEX is mainly for visibility and light trading at first.</li>
                  <li>As the community grows, trading becomes smoother (more liquidity, less slippage).</li>
                </ul>
              </div>

              <div className="policy-subsection">
                <h4>We will</h4>
                <ul>
                  <li>Publish addresses and every liquidity add.</li>
                  <li>Keep DEX price slightly above Public to protect ICO participants.</li>
                  <li>Add depth only when the market shows real demand.</li>
                </ul>
              </div>

              <div className="policy-subsection">
                <h4>We won't</h4>
                <ul>
                  <li>Burn LP tokens (we keep flexibility to manage depth).</li>
                  <li>Do hidden market-making against the community.</li>
                  <li>List at or below ICO prices.</li>
                </ul>
              </div>
            </div>
          )}

          {activePolicy === "treasury" && (
            <div className="policy-item">
              <h3>Treasury Sale Policy</h3>
              <div className="policy-subsection">
                <h4>TL;DR</h4>
                <p>When we need to convert some MCN to pay for development and operations, we'll prefer OTC deals with lockups, not open-market sells. If we ever sell on a DEX, it will be small, rate-limited, and announced.</p>
              </div>

              <div className="policy-subsection">
                <h4>How it works</h4>
                <ul>
                  <li><strong>OTC-first:</strong> Large sales go to partners/investors off-exchange, with vesting/lockups (no instant flips).</li>
                  <li><strong>If DEX is necessary:</strong> We cap daily selling to ≤ 10% of 30-day average DEX volume and spread it using TWAP so it doesn't slam the chart.</li>
                  <li><strong>Pre-announce big moves:</strong> Any treasury sale ≥ 0.5% of circulating supply: 24–48h notice with the reason and terms.</li>
                  <li><strong>Use of proceeds:</strong> Building the product, security/audits, gradual liquidity adds per the ladder, and buybacks during stress.</li>
                </ul>
              </div>

              <div className="policy-subsection">
                <h4>What this means for you</h4>
                <ul>
                  <li>No surprise big sells.</li>
                  <li>We prioritize long-term health (product & liquidity) over short-term cash grabs.</li>
                </ul>
              </div>

              <div className="policy-subsection">
                <h4>We will</h4>
                <ul>
                  <li>Publish a monthly Treasury Report (balances, flows, OTC deals, LP adds, all TX links).</li>
                  <li>Favor OTC with lockups to avoid chart impact.</li>
                </ul>
              </div>

              <div className="policy-subsection">
                <h4>We won't</h4>
                <ul>
                  <li>Dump large amounts on the market.</li>
                  <li>Sell without notice if the sale is ≥0.5% of circulating supply.</li>
                </ul>
              </div>
            </div>
          )}

          {activePolicy === "staking" && (
            <div className="policy-item">
              <h3>Staking Emissions Plan</h3>
              <div className="policy-subsection">
                <h4>TL;DR</h4>
                <p>Stake MCN to earn yield. 6-month plan pays simple interest; 1y/2y/3y/5y plans compound monthly. All rewards are paid from the staking contract's balance, which we keep funded and transparent.</p>
              </div>

              <div className="policy-subsection">
                <h4>Current on-chain plans</h4>
                <ul>
                  <li><strong>6 months:</strong> 5.00% APY, simple interest</li>
                  <li><strong>12 months:</strong> 7.00% APY, monthly compounding</li>
                  <li><strong>24 months:</strong> 10.00% APY, monthly compounding</li>
                  <li><strong>36 months:</strong> 15.00% APY, monthly compounding</li>
                  <li><strong>60 months:</strong> 18.00% APY, monthly compounding</li>
                </ul>
              </div>

              <div className="policy-subsection">
                <h4>Funding & safety</h4>
                <ul>
                  <li>Rewards come from the StakingManager contract's MCN balance.</li>
                  <li>We top the contract up monthly/quarterly, and we display the balance publicly.</li>
                  <li>We use caps (per-plan and overall) to prevent unfunded liabilities and keep APRs healthy.</li>
                </ul>
              </div>

              <div className="policy-subsection">
                <h4>Early withdrawal</h4>
                <p>If the plan allows, you can exit early for principal minus a penalty (no rewards). Penalties stay in the contract to help fund rewards.</p>
              </div>

              <div className="policy-subsection">
                <h4>What this means for you</h4>
                <ul>
                  <li>You know exactly how rewards are computed: the smart contract is the source of truth, and the UI calls it directly.</li>
                  <li>You can see how well the staking pool is funded at any time.</li>
                </ul>
              </div>

              <div className="policy-subsection">
                <h4>We will</h4>
                <ul>
                  <li>Keep the staking contract funded and show a public balance & runway estimate.</li>
                  <li>Publish any change to APY/caps before it goes live.</li>
                  <li>Enforce caps to protect sustainability.</li>
                </ul>
              </div>

              <div className="policy-subsection">
                <h4>We won't</h4>
                <ul>
                  <li>Over-promise yields we don't fund.</li>
                  <li>Change rewards retroactively.</li>
                </ul>
              </div>
            </div>
          )}

          {activePolicy === "burn" && (
            <div className="policy-item">
              <h3>Burn Rule</h3>
              <div className="policy-subsection">
                <h4>TL;DR</h4>
                <p>We burn MCN based on real usage: a fixed slice of monthly revenue + small burns at clear adoption milestones. Every burn has a public transaction link.</p>
              </div>

              <div className="policy-subsection">
                <h4>Two burn tracks</h4>
                <div style={{ marginBottom: "15px" }}>
                  <h5 style={{ marginTop: "10px", marginBottom: "8px" }}>Revenue-linked buyback & burn</h5>
                  <p>We use 10% of monthly net platform revenue to buy MCN on DEX (TWAP) and burn it once a month.</p>
                </div>
                <div>
                  <h5 style={{ marginTop: "10px", marginBottom: "8px" }}>Milestone burns</h5>
                  <ul>
                    <li>Every 100,000 verified active users → burn 5,000,000 MCN</li>
                    <li>Every 1,000 verified partners → burn 2,000,000 MCN</li>
                  </ul>
                  <p>(We may tune these numbers ahead of time to match supply and adoption.)</p>
                </div>
              </div>

              <div className="policy-subsection">
                <h4>Circuit breaker</h4>
                <p>We avoid big "shock burns" during extreme volatility. If markets are unstable, we prefer measured buybacks and keep burns on schedule.</p>
              </div>

              <div className="policy-subsection">
                <h4>What this means for you</h4>
                <ul>
                  <li>Supply reduction is predictable and earned by real usage, not random.</li>
                  <li>You can track every burn on-chain.</li>
                </ul>
              </div>

              <div className="policy-subsection">
                <h4>We will</h4>
                <ul>
                  <li>Maintain a public Burn Ledger page with rule, amount, and TX for every burn.</li>
                  <li>Stick to the rules (revenue % + milestones).</li>
                </ul>
              </div>

              <div className="policy-subsection">
                <h4>We won't</h4>
                <ul>
                  <li>Do surprise "headline" burns to manipulate price.</li>
                  <li>Change the rules without announcing in advance.</li>
                </ul>
              </div>
            </div>
          )}
        </div>

        {/* Glossary */}
        <div className="policies-glossary">
          <h3>📖 Quick Glossary</h3>
          <div className="glossary-grid">
            <div className="glossary-item">
              <strong>DEX:</strong> Decentralized Exchange (e.g., Uniswap)
            </div>
            <div className="glossary-item">
              <strong>TVL:</strong> Total Value Locked in the trading pool (depth/liquidity)
            </div>
            <div className="glossary-item">
              <strong>OTC:</strong> Over-the-counter, private deal with agreed vesting/lockups
            </div>
            <div className="glossary-item">
              <strong>TWAP:</strong> Time-Weighted Average Price execution to avoid big price impact
            </div>
            <div className="glossary-item">
              <strong>APY:</strong> Annual Percentage Yield (with compounding if specified)
            </div>
            <div className="glossary-item">
              <strong>Simple interest:</strong> Straight-line interest; no compounding
            </div>
            <div className="glossary-item">
              <strong>LP tokens:</strong> Receipts for providing liquidity; we don't burn them
            </div>
          </div>
        </div>
      </div>
    </div>
    
  );
};

export default Tokenomics;
